// services/bucketService.js

const BASE_URL = import.meta.env.VITE_BACKEND_URL || '';

/**
 * Trata a resposta do fetch, lançando erro com mensagem
 * vinda do body.error ou o texto bruto.
 */
async function handleResponse(res) {
  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch { data = null; }

  if (!res.ok) {
    const errMsg = data?.error || text || `HTTP ${res.status}`;
    throw new Error(errMsg);
  }

  return data;
}

/**
 * Busca a lista de buckets + métricas
 */
export async function fetchBuckets() {
  const token = localStorage.getItem('token');
  console.log('[fetchBuckets] GET /api/bucket-metrics');
  const res = await fetch(`${BASE_URL}/api/bucket-metrics`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  console.log('[fetchBuckets] status:', res.status);
  const payload = await handleResponse(res);
  console.log('[fetchBuckets] payload:', payload);
  return payload.buckets; // array de buckets com métricas
}

/**
 * Cria um novo bucket com o nome informado
 */
export async function createBucket(name) {
  const token = localStorage.getItem('token');
  console.log('[createBucket] nome:', name);
  const res = await fetch(`${BASE_URL}/api/buckets`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ name }),
  });
  console.log('[createBucket] status:', res.status);
  const text = await res.text();
  console.log('[createBucket] body text:', text);
  // reconstroi um Response-like para o handleResponse
  const fakeRes = new Response(text, { status: res.status });
  return handleResponse(fakeRes);
}

/**
 * Deleta um bucket pelo nome (id)
 */
export async function deleteBucket(name) {
  const token = localStorage.getItem('token');
  console.log('[deleteBucket] nome:', name);
  const res = await fetch(
    `${BASE_URL}/api/buckets/${encodeURIComponent(name)}`,
    {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  console.log('[deleteBucket] status:', res.status);
  const text = await res.text();
  console.log('[deleteBucket] body text:', text);
  const fakeRes = new Response(text, { status: res.status });
  return handleResponse(fakeRes);
}
